import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import Especialidades from "./sections/Especialidades";
import Trust from "./sections/Trust";
import Ready from "./sections/Ready";
import Cobertura from "./sections/Cobertura";
import Quote from "./sections/Quote";
import Footer from "@/reusable_sections/Footer";
import Workflow from "./sections/Workflow";
import Testimonials from "./sections/Testimonials";
import Coberturasureste from "./sections/Coberturasureste";
import Store from "./sections/Store";
export default function HomePage() {
  return <div>
      <Header />
      <Hero />
      <Especialidades />
      <Cobertura />
      <Trust />
      <Workflow />
      <Testimonials />
      <Coberturasureste />
      <Ready />
      <Quote />
      <Store />
      <Footer />
    </div>;
}